import { normalizeHexColor } from './parseHexColor';

export function generateGradientString(colors: string[]): string {
  const angle = '135deg';
  const percentageStep = 100 / colors.length;

  if (colors.length === 0) {
    return '';
  }
  const colorStops = colors.map((rawColor, index) => {
    // Hex-Werte auf `#rrggbb` bringen: ohne führendes `#` ist der Wert als CSS-Farbe ungültig
    // und verwirft den kompletten Verlauf – die Karte bliebe grau. Alles, was kein Hex ist
    // (z.B. CSS-Farbnamen), bleibt unverändert, weil es in CSS gültig sein kann.
    const color = normalizeHexColor(rawColor) ?? rawColor;
    const startPercentage = index * percentageStep;
    const endPercentage = startPercentage + percentageStep;
    return `${color} ${startPercentage.toFixed(3)}%, ${color} ${endPercentage.toFixed(3)}%`;
  });

  return `linear-gradient(rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0) 5px), linear-gradient(${angle}, ${colorStops.join(
    ', ',
  )})`;
}
